import * as actionTypes from '../actions/actionTypes';
import getCookiesManager from '../utils/cookiesManager';

const getCookiesBarHidden = () => {
  if (getCookiesManager()) {
    return getCookiesManager().getBoolValue('cookiesBarHidden', COUNTRY, false);
  }

  return true;
};

const initialState = {
  cookiesBarHidden: getCookiesBarHidden(),
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.HIDE_COOKIES_BAR:
      return {
        ...state,
        cookiesBarHidden: true,
      };

    default:
      return state;
  }
}
